import axios from '@api/axios';
import { ChatChannelDetailsRequest, ChatChannelDetailsResponse, GetCustomTokenResponse } from '@server/controllers/ChatController';
import { ChatFileUploadRequest, ChatFileUploadResponse } from '@server/controllers/UploadController';

class ChatController {
  public async getCustomToken(): Promise<string> {
    const response = await axios.get<GetCustomTokenResponse>(`/api/user/chat-custom-token`);
    return response.data.customToken;
  }

  public async getChatChannelDetails(request: ChatChannelDetailsRequest): Promise<ChatChannelDetailsResponse> {
    const response = await axios.post<ChatChannelDetailsResponse>(`/api/user/chat-channel-details`, request);
    return response.data;
  }

  public async getChatFileUploadS3Policies(request: ChatFileUploadRequest): Promise<ChatFileUploadResponse> {
    const response = await axios.post<ChatFileUploadResponse>(`/api/user/chat-file-upload`, request);
    return response.data as ChatFileUploadResponse;
  }
}

export default ChatController;
